import {h, Fragment} from "preact"
export default function ProductSearchCard({ product }) {
    return product?.handle ? (
      <dynamic-product-card-search
        handle={product.handle}
        class="search_product_card"
      />
    ) : null;
  }
  